import BaseButton, { ButtonHandle, ButtonProps as BaseButtonProps } from 'carbon-react/lib/components/button/__next__';
import { VariantType } from 'carbon-react/lib/components/button/__next__/button.config';
import styled, { css } from 'styled-components';
import { EnhancedButtonType, getEnhancedButtonType } from '../hooks';

const embeddedStyle = css`
  min-height: 32px;
`;

const StyledButton = styled(BaseButton)`
  ${embeddedStyle}
`;

export interface ButtonProps extends Omit<BaseButtonProps, 'variantType'> {
  tabIndex?: number;
  variantType?: EnhancedButtonType<VariantType>;
}

const Button = ({ variantType: enhancedVariantType, ref, ...props }: ButtonProps & { ref?: React.Ref<ButtonHandle> }) => {
  const variantType = getEnhancedButtonType(enhancedVariantType);
  return <StyledButton ref={ref} variantType={variantType} {...props} />;
};

export default Button;
